import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import PolypaneIntro from "../../../../src/components/PolypaneIntro";
import ThanksCallout from "../../../../src/components/ThanksCallout";
import areascreenshots from "../../../../assets/videos/blogs/pp30/areascreenshot.mp4";
import textselection from "../../../../assets/videos/blogs/pp30/textselection.mp4";
import panescales from "../../../../assets/videos/blogs/pp30/panescales.mp4";
import svhoverlays from "../../../../assets/images/blogs/pp30/svh.png";
import initiator from "../../../../assets/images/blogs/pp30/initiator.png";
import networkfilter from "../../../../assets/images/blogs/pp30/filter.png";
import quirksmode from "../../../../assets/images/blogs/pp30/quirksmode.png";
import sidepanel from "../../../../assets/images/blogs/pp30/sidepanel.png";
import textscale from "../../../../assets/images/blogs/pp30/textscale.png";
import standardsitepreview from "../../../../assets/images/blogs/pp30/standardsitepreview.png";
import robotsplaintext from "../../../../assets/images/blogs/pp30/plaintext.png";
import commandforelement from "../../../../assets/images/blogs/pp30/commandforelement.png";
import ifsupport from "../../../../assets/images/blogs/pp30/ifsupport.png";
import focusorder from "../../../../assets/images/blogs/pp30/focusorder.png";
import mastodonpreview from "../../../../assets/images/blogs/pp30/mastodon.png";
import a11ytooltip from "../../../../assets/images/blogs/pp30/a11ytooltip.png";
import largeogpreview from "../../../../assets/images/blogs/pp30/largeog.png";
import defaultnewprojecttab from "../../../../assets/images/blogs/pp30/defaultnewprojecttab.png";
import new30devices from "../../../../assets/images/blogs/pp30/new30devices.png";
import playgroundsmanager from "../../../../assets/images/docs/playgrounds/playgroundsmanager.png";
import directorylisting from "../../../../assets/images/docs/playgrounds/directorylisting.png";
import playgroundportal from "../../../../assets/videos/docs/playgrounds/portal.mp4";
import standardsite from "../../../../assets/images/docs/meta/standardsite.png";
import pickdevtools from "../../../../assets/images/docs/devtools/pickdevtools.png";
import arrayelems from "../../../../assets/images/blogs/pp30/arrayelems.png";
import sameworld from "../../../../assets/images/blogs/pp30/sameworld.png";
import video1 from "../../../../assets/videos/recording/video1.mp4";
import paneheader from "../../../../assets/images/docs/panes/paneheader.png";
import paneheaderhovered from "../../../../assets/images/docs/panes/paneheaderhovered.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  PolypaneIntro,
  ThanksCallout,
  areascreenshots,
  textselection,
  panescales,
  svhoverlays,
  initiator,
  networkfilter,
  quirksmode,
  sidepanel,
  textscale,
  standardsitepreview,
  robotsplaintext,
  commandforelement,
  ifsupport,
  focusorder,
  mastodonpreview,
  a11ytooltip,
  largeogpreview,
  defaultnewprojecttab,
  new30devices,
  playgroundsmanager,
  directorylisting,
  playgroundportal,
  standardsite,
  pickdevtools,
  arrayelems,
  sameworld,
  video1,
  paneheader,
  paneheaderhovered,
  React
};